import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// Fetch workout templates with pagination
export const fetchWorkoutTemplatesApi = async ({
  coachId,
  pageNumber = 1,
  pageSize = 10,
}) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_WORKOUT_TEMPLATE}/${coachId}`,
    {
      params: { PageNumber: pageNumber, PageSize: pageSize },
    }
  );

  return {
    workoutTemplates: response.data.workoutTemplates,
    totalCount: response.data.totalCount,
  };
};

export const deleteWorkoutTemplateApi = async (templateId) => {
  const response = await axiosInstance.post(
    `${Endpoints.DELETE_WORKOUT_TEMPLATE}/${templateId}`
  );
  return response.data;
};

export const createWorkoutTemplateApi = async (workoutData) => {
  const response = await axiosInstance.post(
    Endpoints.CREATE_WORKOUT_TEMPLATE,
    workoutData
  );
  return response.data;
};

export const fetchWorkoutTemplateByIdApi = async (templateId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_WORKOUT_TEMPLATE_DETAILS_BY_ID}/${templateId}`
  );
  return response.data;
};

export const filterWorkoutTemplatesApi = async ({ coachId, name }) => {
  const params = { name: name || undefined };

  const response = await axiosInstance.get(
    `${Endpoints.FILTER_WORKOUT_TEMPLATE}/${coachId}`,
    { params }
  );

  return {
    workoutTemplates: response.data.workoutTemplates,
    totalCount: response.data.totalCount,
  };
};

export const updateWorkoutTemplateApi = async (templateId, workoutData) => {
  const response = await axiosInstance.post(
    `${Endpoints.UPDATE_WORKOUT_TEMPLATE}/${templateId}`,
    workoutData
  );
  return response.data;
};
